<template>
	<Tippy :content="show ? errorMsg : null">
		<div
			v-show="show"
			class="char-limit"
			:class="{ red, max }"
			v-text="
				max ? $t('chat_excessivetext_counter_placeholder') : charsRemaining
			"
		/>
	</Tippy>
</template>

<script>
import { MAX_CHARS } from '@/helpers/constants'
import { Tippy } from '@/components/common'

export const WARN_LIMIT = 15
export const ERROR_LIMIT = 10
export const MAX_LIMIT = -99

const encoder = new TextEncoder('utf-8')
export const getStringBytes = (str) => {
	if (!str?.trim) return 0
	return encoder.encode(str.trim()).length
}

export default {
	name: 'MessageCharLimit',
	components: { Tippy },
	props: {
		text: String,
	},

	beforeUnmount() {
		this.closeOverMaxAlert()
	},

	computed: {
		characterCount() {
			return getStringBytes(this.text)
		},

		charsRemaining() {
			return MAX_CHARS - this.characterCount
		},

		show() {
			return this.charsRemaining <= WARN_LIMIT
		},

		red() {
			return this.charsRemaining <= ERROR_LIMIT
		},

		max() {
			return this.charsRemaining <= MAX_LIMIT
		},

		errorMsg() {
			return this.$t('chat_excessivetext_error_message', [MAX_CHARS])
		},
	},

	emits: ['over', 'under'],
	
	watch: {
		characterCount() {
			const isOver = this.charsRemaining < 0
			if (isOver && !this.overMaxAlert) {
				this.$emit('over')
				this.showOverMaxAlert()
			} else if (!isOver && this.overMaxAlert) {
				this.$emit('under')
				this.closeOverMaxAlert()
			}
		},
	},

	methods: {
		showOverMaxAlert() {
			this.overMaxAlert = this.$alert.error(this.errorMsg)
		},

		closeOverMaxAlert() {
			this.overMaxAlert?.()
			this.overMaxAlert = null
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.char-limit {
	font-size: 14px;
	color: var(--neutral-600);
	width: 42px;
	padding-bottom: 5px;
	border-bottom: 2px solid #f7d24a;
	text-align: center;
	&.red {
		border-color: var(--red-200);
	}
	&.max {
		color: var(--red-200);
	}
}
</style>
